import * as r from 'ramda';
import { validate } from './validate';

/**
 * Returns a random number n such that { n | [0, ceiling) }
 * @param {number} ceiling
 */
const getRandomWholeNumber = (ceiling: number) => Math.floor(Math.random() * ceiling);

/**
 * Returns a random member from an array or list.
 */
const _getRandomItem = r.curry((arr: never[]) => getRandomWholeNumber(arr.length));

const getRandomItem = r.curry(_getRandomItem);

export {
  getRandomWholeNumber,
  getRandomItem,
  validate,
};
